export default __webpack_public_path__ + "static/media/nico-moreno.9df24abc.jpg";